var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from "styled-components";
import FilterBy from "@irati/ui/src/FilterBy";
import SortBy from "@irati/ui/src/SortBy";
import { Body } from "@irati/ui/src/Typography";
var commonStyles = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 5px;\n  width: 100%;\n  max-width: 100%;\n\n  ", "\n"], ["\n  margin-bottom: 5px;\n  width: 100%;\n  max-width: 100%;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.desktop(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: 0;\n    max-width: 280px;\n  "], ["\n    margin-bottom: 0;\n    max-width: 280px;\n  "])));
});
export var StyledFilterBy = styled(FilterBy)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ",
    "\n"])), commonStyles, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.desktop(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.spacing.one);
});
export var StyledSortBy = styled(SortBy)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), commonStyles);
export var DisplayCount = styled(Body)(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
